var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorP"},[_c('div',{staticClass:"errorP-inner"},[_vm._m(0),_c('p',[_vm._v("삭제되었거나 존재하지 않는 게시물입니다.")]),_c('a',{staticClass:"btn color-1 btn-large w-200 btn-round100",on:{"click":_vm.goBack}},[_vm._v("이전 페이지 이동")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('img',{attrs:{"src":require("@/assets/img/sub/notice.png"),"alt":""}})])
}]

export { render, staticRenderFns }